export default __webpack_public_path__ + "static/proximity-do-577a31a4973abe07935a447479bae3c0d99365357fe0db51c5001c079c460f2a.png";